import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-10 px-4" data-id="element-179">
      <div className="max-w-xl mx-auto text-center" data-id="element-180">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-brand-cream mb-4" data-id="element-181">
          Quanto tempo stai perdendo,{' '}
          <span className="text-brand-orange" data-id="element-182">davvero?</span>
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base sm:text-lg text-gray-300 leading-relaxed" data-id="element-183">
          Programmare manualmente ogni lezione ti toglie in media da{' '}
          <span className="text-brand-danger font-bold" data-id="element-184">
            4 a 6 ore a settimana
          </span>
          . Più di{' '}
          <span className="text-brand-danger font-bold" data-id="element-185">
            200 ore all'anno perse
          </span>
          . Per sempre.
        </motion.p>
      </div>
    </section>;
}